export default "__VITE_ASSET__aZgI5WhH__"